import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["wrapper", "modal", "container"]

  show(event) {
    event.preventDefault();

    this.wrapperTarget.classList.remove("invisible");
    this.modalTarget.src = event.params.url;
    document.body.classList.add("overflow-hidden");
  }

  hide(event) {
    event.preventDefault();

    this.wrapperTarget.classList.add("invisible");
    this.modalTarget.src = "";
    this.modalTarget.innerHTML = "";
    document.body.classList.remove("overflow-hidden");

    // Reset expanded state when closing
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("max-w-4xl");
      this.containerTarget.classList.remove("max-w-[95vw]", "max-h-[95vh]");
    }
  }

  toggleExpand(event) {
    event.preventDefault();

    if (!this.hasContainerTarget) return

    const container = this.containerTarget
    const isExpanded = !container.classList.contains("max-w-4xl")

    if (isExpanded) {
      container.classList.add("max-w-4xl")
      container.classList.remove("max-w-[95vw]", "max-h-[95vh]")
    } else {
      container.classList.remove("max-w-4xl")
      container.classList.add("max-w-[95vw]", "max-h-[95vh]")
    }
  }

  disconnect() {
    this.modalTarget.src = null;
  }
}
